<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import type { RouterLinkProps as VueRouterLinkProps } from 'vue-router'

import BaseButton, { type BaseButtonProps } from './BaseButton.vue'

type BaseButtonInherits = Omit<BaseButtonProps, 'component' | 'type'>
export type RouterLinkButtonProps = Omit<VueRouterLinkProps, 'custom'> & BaseButtonInherits

const props = defineProps<RouterLinkButtonProps>()
const attrs = useAttrs()

defineSlots<InstanceType<typeof BaseButton>['$slots']>()

defineOptions({
  inheritAttrs: false,
})

const toBind = computed(() => {
  const {
    // decouple link props from button props
    to,
    replace,
    activeClass,
    exactActiveClass,
    ariaCurrentValue,
    ...buttonProps
  } = props

  return {
    link: {
      to,
      replace,
      activeClass,
      exactActiveClass,
      ariaCurrentValue,
    },
    button: {
      ...buttonProps,
      ...attrs,
    },
  }
})
</script>

<template>
  <RouterLink v-slot="{ href: routerHref, navigate }" v-bind="toBind.link" custom>
    <BaseButton v-bind="toBind.button" component="a" :type="undefined" :href="routerHref" @click="navigate">
      <template v-for="(_, name) in $slots" #[name]>
        <slot :name="name" />
      </template>
    </BaseButton>
  </RouterLink>
</template>
